<template>
<div>
  <div>
    <card>
      <div slot="title">
        <div class="flex" style="justify-content: space-between">
          <h4>管家业绩</h4>
          <select-range  @search="search" ref="date"></select-range>
        </div>
      </div>
<!--      :total="total" :current="current" @change-page="changePage"-->
      <Table
        :columns="columns" :data="data" :loading="loading"
      ></Table>
    </card>

  </div>

</div>
</template>

<script>
  import Card from './Card'
  import SelectRange from './SelectRange'
  // import TableList from 'components/TableList'
  import {zoAchievement} from "../../../api/homepage";

  export default {
    name: "GOPerformance",
    components:{
      Card,
      SelectRange,
      // TableList
    },
    data(){
      return {
        current:1,
        total:0,
        loading:false,
        data:[],
        columns:[
          {
            title: '员工',
            key: 'zoName',
            align: 'center',
            width:120
          },
          {title:' '},
          {
            title: '客源',
            key: 'customerCount',
            align: 'center',
            width:120,
          },
          {title:' '},
          {
            width:120,
            title: '已带看',
            key: 'businessLookCount',
            align: 'center'
          },
          {title:' '},
          {
            width:120,
            title: '新签',
            key: 'newSignCount',
            align: 'center'
          },
          {title:' '},
          {
            width:120,
            title: '接听率',
            key: 'pickRate',
            align: 'center'
          },
          {title:' '},
          {
            width:120,
            title: '及时跟进率',
            key: 'inTimeRate',
            align: 'center'
          },
          {title:' '},
          {
            width:150,
            title: '客源-带看',
            key: 'customerLookRate',
            align: 'center'
          },
          {title:' '},
          {
            width:150,
            title: '带看-签约',
            key: 'lookSignRete',
            align: 'center'
          },
          {
            width:150,
            title: '客源-签约率',
            key: 'customerSignRate',
            align: 'center'
          },
          // {title:' '},
          // {
          //   width:150,
          //   title: '管家未处理商机',
          //   key: 'confirmRescissionByFollowedUp',
          //   align: 'center'
          // },
          // {title:' '},
          // {
          //   width:150,
          //   title: '管家超时待办',
          //   key: 'undeterminedByFollowedUp',
          //   align: 'center'
          // },

        ]
      }
    },
    watch:{
      projectFidList(value){
        // this.current=1
        this.search(this.$refs['date'].searchParams)
      }

    },
    props:{
      projectFidList:{
        type:Array,
        default(){
          return []
        }
      }

    },
    methods:{
      search(data){
        // this.current=1
        const params={
          projectFidList:this.projectFidList,
          ...data,
        }
        this.loading=true
        zoAchievement(params).then(res=>{
          this.data=res.data||[]

        }).catch(error=>{}).finally(()=>{
          this.loading=false
        })

      },
      // changePage(n){
      //   this.current=n
      //   let params={
      //     ...this.searched,
      //     page:this.current
      //   }
      //   zoAchievement(params).then(res=>{
      //
      //   }).catch(error=>{})
      //
      // }
    }
  }
</script>

<style scoped>

</style>
